import axios from 'axios';
import { getTokenFromCookie } from '../utils/tokenHelper';

export interface InviteApplicationData {
  jobId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  resume?: File | null;
}

export interface InviteApplicationResponse {
  success: boolean;
  applicantGuid?: string;
  hash?: string;
  message?: string;
  error?: string;
  statusCode?: number;
}

export const createApplication = async (applicationData: InviteApplicationData): Promise<InviteApplicationResponse> => {
  try {
    const token = getTokenFromCookie();
    
    const formData = new FormData();
    formData.append('jobId', applicationData.jobId);
    formData.append('firstName', applicationData.firstName);
    formData.append('lastName', applicationData.lastName);
    formData.append('email', applicationData.email);
    
    if (applicationData.phone) {
      formData.append('phone', applicationData.phone);
    }
    
    if (applicationData.resume) {
      formData.append('resume', applicationData.resume);
    }

    const response = await axios.post('/api/v1/invite/create-application', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error: any) {
    console.error('Error creating application:', error);
    
    if (error.response?.data) {
      return error.response.data;
    }
    
    return {
      success: false,
      message: 'Failed to create application. Please try again.'
    };
  }
};